// extracted by mini-css-extract-plugin
export default {"v-focusedBlue":"#66afe9","root":"bootstrap__root__B6Mfc"};